export default {
  discount_badge: '{{value}} Rabatt',
};
